import { Injectable } from '@angular/core';

export interface AppConfig {
  oauthUrl: string;
  apiUrl: string;
  clientId: string;
  origin: string;
}

let appConfig: AppConfig | null = null;

export async function loadAppConfig(): Promise<AppConfig> {
  const response = await fetch('/assets/app-config.json');
  if (!response.ok) {
    throw new Error('Failed to load app configuration');
  }
  const config: AppConfig = await response.json();
  appConfig = config;
  return config;
}

export function getAppConfig(): AppConfig {
  if (!appConfig) {
    throw new Error('App configuration not loaded. Call loadAppConfig() first.');
  }
  return appConfig;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  get config(): AppConfig {
    return getAppConfig();
  }

  get oauthUrl(): string {
    return this.config.oauthUrl;
  }

  get apiUrl(): string {
    return this.config.apiUrl;
  }

  get clientId(): string {
    return this.config.clientId;
  }

  get origin(): string {
    return this.config.origin;
  }
}
